
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pokoje/[slug]",
      function () {
        return require("private-next-pages/pokoje/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pokoje/[slug]"])
      });
    }
  